.button {
  display: inline-grid;
  place-items: center;
  flex: none;
  padding: 0;
  border: var(--border-width) solid transparent;
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--color-text);
  cursor: pointer;
  transition:
    background-color var(--duration-fast) var(--ease-standard),
    color var(--duration-fast) var(--ease-standard),
    transform var(--duration-fast) var(--ease-standard);
}

.button:active:not(:disabled) {
  transform: scale(0.94);
}

.button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.sm {
  width: var(--control-sm);
  height: var(--control-sm);
}

.md {
  width: var(--control-md);
  height: var(--control-md);
}

.lg {
  width: var(--control-lg);
  height: var(--control-lg);
  border-radius: var(--radius-full);
}

.ghost:hover:not(:disabled),
.ghost[data-state="open"] {
  background: var(--color-surface-hover);
}

.secondary {
  background: var(--color-surface-raised);
  border-color: var(--color-border-strong);
}

.secondary:hover:not(:disabled) {
  background: var(--color-surface-hover);
}

/* "Off" state of a toggle (muted microphone, camera off): quiet but clearly distinct. */
.muted {
  background: var(--color-surface-sunken);
  color: var(--color-text-muted);
}

.muted:hover:not(:disabled) {
  background: var(--color-surface-pressed);
  color: var(--color-text);
}

.primary {
  background: var(--color-accent);
  color: var(--color-on-accent);
}

.primary:hover:not(:disabled) {
  background: var(--color-accent-hover);
}

.danger {
  background: var(--color-danger);
  color: var(--color-on-danger);
}

.danger:hover:not(:disabled) {
  background: var(--color-danger-hover);
}

.tip {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
}

.kbd {
  padding: 0 var(--space-1);
  border-radius: var(--radius-xs);
  background: color-mix(in srgb, currentColor 16%, transparent);
  font-family: inherit;
  font-size: var(--text-xs);
}
